import { UrlService } from "../../../services/UrlService";

export async function loadConfiguration(param: any) {
  //@ts-ignore
  const containerRef = window.containerRef;
  const canvasIframe = containerRef.current.contentWindow;
  const processedParam = UrlService.processConfigurationUrls(JSON.parse(param));
  const canvasCoords = await canvasIframe.LoadConfig(JSON.stringify(processedParam));

  return canvasCoords;
}
